import type { IconData } from '@stacksjs/iconify-core'

export const files: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 15H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h3l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm0-2V7a2 2 0 0 1 2-2h2V2H2v11zm8.172-6H8v11h8V8.828z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default files
